'use strict';

var baseMiniCart = require('richemont/components/miniCart');
var $miniCartIcon = $('.minicart .minicart-icon');
var $miniCart = $('.minicart');
var $body = $('body');
var updateMiniCart = true;

baseMiniCart.miniCartClick = function () {
    $(document).on('click', '.minicart-link', function () {
        const url = $('.minicart').data('redirect-url');
        window.location.href = url;
    });
};

baseMiniCart.miniCartCountClick = function () {
    $(document).on('click', '.minicart-link', function (e) {
        if (app.isDesktop()) {
            e.preventDefault();
            e.stopPropagation();
            $body.trigger('minicart:update');
        }
    });
};

baseMiniCart.init = function () {
    const eventNamespace = '.minicartHover';
    if (!('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
        $(document)
            .off('mouseenter focusin touchstart', '.minicart')
            .on('mouseenter focusin touchstart', '.minicart', function (e) {
                if ($('#minicart-overlay-slider').is(':visible') || !app.isDesktop()) {
                    return;
                }
                e.stopPropagation();
                $body.trigger('minicart:update', { openSlider: true });
                $miniCartIcon.addClass('hover-active');
            });
    }

    if (!app.checkBreakPoint('lg')) {
        $(document).off('mouseenter' + eventNamespace, '.minicart');
    }
};

baseMiniCart.handleHoverState = function () {
    let isInside;
    /**
     * Sets the hover state for the minicart overlay and removes active classes when the user leaves.
     *
     * @param {boolean} state - Represents whether the mouse is currently hovering inside
     *                          the minicart area (`true`) or outside (`false`).
     */
    function setHoverState(state) {
        isInside = state;
        if (!isInside) {
            $('#minicart-overlay-slider').removeClass('active slider-animate');
        }
    }
    $(document).on('mouseleave', '.minicart-overlay-wrapper, .slider-wrapper', function () {
        setHoverState(false);
        if ($miniCartIcon.hasClass('hover-active')) {
            $miniCartIcon.removeClass('hover-active');
            $('body').removeClass('slider-open');
        }
    });
};

baseMiniCart.minicartUpdateInit = function () {
    $body.on('product:beforeAddToCart cart:beforeUpdate', function () {
        updateMiniCart = true;
    });
};

/**
 * Override: update minicart content but don't auto-open
 */
baseMiniCart.miniCartUpdate = function () {
    let minicartLoading = false;
    $body.off('minicart:update').on('minicart:update', function (event, options) {
        if (!updateMiniCart) {
            $(document).trigger('openSlider', {
                target: '#minicart-overlay-slider',
            });
            $.spinner().stop();
            return;
        }
        if (minicartLoading) return;
        var shouldOpenSlider = options && options.openSlider === true;
        var keepMiniCartOpen = options && options.keepMiniCartOpen === true;
        var url = $miniCart.data('action-url');
        minicartLoading = true;
        $.get(url, function (data) {
            if (!keepMiniCartOpen) {
                $('.minicart-overlay-wrapper').remove();
                $body.removeClass('slider-open');
                $miniCart.append(data);
            }

            if (keepMiniCartOpen) {
                $('.minicart-overlay-wrapper').replaceWith(data);
            }
            if (shouldOpenSlider || keepMiniCartOpen) {
                if ($('.minicart-overlay-wrapper .product-summary .card').length === 0) {
                    $miniCart.find('.empty-mini-cart').addClass('active slider-animate');
                    $miniCart.find('.has-items').remove();
                } else {
                    $miniCart.find('.has-items').addClass('active slider-animate');
                    $miniCart.find('.empty-mini-cart').remove();
                }
            }
            baseMiniCart.updateMiniCartQuantityUI();
            if ($('.cartmain').length) {
                $('.cart-title-wrapper .cart-count .count-text').empty().append($('.minicart-quantity').html().trim());
            }
            minicartLoading = false;
            updateMiniCart = false;
            $body.trigger('gtm:trigger:event', { eventId: $miniCart.find('#gtmEventDetails').attr('data-event') });
            $.spinner().stop();
        });
    });
};

module.exports = baseMiniCart;
